(function(){
  if(window.JanineBespoke)return;
  const instances=new WeakMap();
  const reveal=root=>{
    const nodes=root.querySelectorAll('.janine-bespoke__reveal:not(.is-visible)');
    if(!nodes.length)return;
    if(!('IntersectionObserver'in window)||window.matchMedia('(prefers-reduced-motion: reduce)').matches){nodes.forEach(node=>node.classList.add('is-visible'));return}
    const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}})},{threshold:.12,rootMargin:'0px 0px -7%'});
    nodes.forEach(node=>observer.observe(node));
  };
  const initCarousel=section=>{
    if(instances.has(section))return;
    const track=section.querySelector('[data-bespoke-track]');
    const prev=section.querySelector('[data-bespoke-prev]');
    const next=section.querySelector('[data-bespoke-next]');
    if(!track)return;
    const amount=()=>{const card=track.querySelector('.janine-bespoke-projects__card');return card?card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||0):track.clientWidth};
    const move=direction=>track.scrollBy({left:direction*amount(),behavior:'smooth'});
    prev&&prev.addEventListener('click',()=>move(-1));
    next&&next.addEventListener('click',()=>move(1));
    let timer;
    const delay=Number(section.dataset.autoplay||0)*1000;
    const start=()=>{if(delay<1500||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;stop();timer=window.setInterval(()=>{const edge=track.scrollWidth-track.clientWidth-2;if(track.scrollLeft>=edge)track.scrollTo({left:0,behavior:'smooth'});else move(1)},delay)};
    const stop=()=>{if(timer)window.clearInterval(timer)};
    section.addEventListener('mouseenter',stop);
    section.addEventListener('mouseleave',start);
    section.addEventListener('focusin',stop);
    section.addEventListener('focusout',start);
    start();
    instances.set(section,{stop});
  };
  const init=root=>{reveal(root);root.querySelectorAll('.janine-bespoke-projects').forEach(initCarousel)};
  const boot=()=>init(document);
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot,{once:true}):boot();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>{const section=event.target.querySelector('.janine-bespoke-projects');const instance=section&&instances.get(section);instance&&instance.stop()});
  window.JanineBespoke={init};
})();
